module.exports = __webpack_public_path__ + "img/Pill.367b26a7.jpg";